import { toNumber } from 'lodash';

const parseNegativeValues = (value) =>
  value && toNumber(value) !== 0 ? `- ${value}` : '0';

export default parseNegativeValues;
